import md5 from "md5";
import shihuo from 'shihuo-lib/dist/shihuo-lib'
import clipboardCopy from "./clipboard-copy";
import px2rem from './px2rem';
import { isTablet } from "react-device-detect";

const innerWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
const isTabletDevice = isTablet && innerWidth > 600;

const scene = getParams('scene') || 'shihuoApp';
const iframe = getParams('isIframe') == '1';
let nativeInfo = getParams('nativeInfo');
let colorScheme = '', safeBottomHeight = 0, statusBarHeight = 0;
if (nativeInfo) {
  nativeInfo = JSON.parse(nativeInfo);
  colorScheme = nativeInfo.colorScheme || 'light';
  safeBottomHeight = nativeInfo.safeBottomHeight || 0;
  statusBarHeight = nativeInfo.statusBarHeight || 0;
}

function isAndroid() {
  if (typeof window === "undefined") {
    return true;
  }
  return (
    navigator.userAgent.indexOf("Android") > -1 ||
    navigator.userAgent.indexOf("Adr") > -1
  );
}
function isHuPuAPP() {
  if (typeof window === "undefined") {
    return true;
  }
  return (
    navigator.userAgent.indexOf("hupush") > -1 ||
    navigator.userAgent.indexOf("kanqiu") > -1
  );
}
function parseToken(obj) {
  let paramsToken = "";

  Object.keys(obj)
    .sort()
    .forEach((item) => {
      if (obj[item]) {
        paramsToken += obj[item].toString();
      }
    });

  paramsToken += "123456";

  return md5(paramsToken);
}

//判断是否在识货中
function isShihuo() {
  if (typeof window === "undefined") {
    return true;
  }
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf("shihuo") > -1) {
    return true;
  } else {
    return false;
  }
}

// 获取指定url字符串中的参数
function getUrlParams(url, name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = url.split("?")[1].match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null; //返回参数值
}

//获取链接参数
function getParams(name) {
  if (typeof window == 'undefined') return null;
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]); // 使用 decodeURIComponent  
  }
  return null;
}

function getQueryString(name) {
  if (typeof window == 'undefined') return null;
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]); return null;
}

function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)"),
    iosreg = new RegExp("(^|)" + name + "=([^;]*)(;|$)");

  return new Promise((resolve) => {
    if (isShihuo()) {
      //resolve(null)
      //return false
      try {
        if (document.cookie.indexOf("sensorsdata2015jssdkcross") > -1) {
          document.cookie =
            "sensorsdata2015jssdkcross=; path=/; domain=.shihuo.cn; expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
        window.Jockey.send(
          "fetchCookies",
          { url: "http://www.shihuo.cn" },
          (res) => {
            if (res.status == 0) {
              if (isAndroid()) {
                arr = decodeURIComponent(res.data.str).match(reg);
              } else {
                arr = decodeURIComponent(res.data.str).match(iosreg);
              }
              if (arr) {
                resolve(unescape(arr[2]));
              } else {
                resolve(null);
              }
            } else {
              resolve(null);
            }
          }
        );
      } catch (e) {
        console.log(e);
        resolve(null);
      }
    } else {
      if ((arr = document.cookie.match(reg))) {
        resolve(unescape(arr[2]));
      } else {
        resolve(null);
      }
    }
  });
}

function getDeviceInfo() {
  return new Promise((resolve) => {
    if (isShihuo()) {
      window.Jockey.send("device", {}, (res) => {
        console.log(`device-------`, res);
        resolve({
          deviceId: res.idfa || res.deviceId,
          abtest_tag: res.abtest_tag || "",
        });
      });
    } else {
      resolve({
        deviceId: "",
        abtest: "",
      });
    }
  });
}

async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

function convertHref(href) {
  if (-1 == href.indexOf("shihuo://www.shihuo.cn?")) {
    var mdStr = href.split("#%7B")[1];
    var href = href.split("#%7B")[0];
    // app首页
    var webHomeRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/?$/i;
    if (webHomeRegExp.test(href)) {
      return href.replace(
        webHomeRegExp,
        "shihuo://www.shihuo.cn?route=index" + (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 商品列表
    var goodsListRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/sports\/list\?(.+)$/i;
    if (goodsListRegExp.test(href)) {
      return href.replace(
        goodsListRegExp,
        "shihuo://www.shihuo.cn?route=goodsList&$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 篮球专区
    var basketballRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/basketball$/i;
    if (basketballRegExp.test(href)) {
      return href.replace(
        basketballRegExp,
        "shihuo://www.shihuo.cn?route=basketball" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }
    var basketballParamRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/basketball\?haojiaId=(\d+)$/i;
    if (basketballParamRegExp.test(href)) {
      return href.replace(
        basketballParamRegExp,
        "shihuo://www.shihuo.cn?route=basketball&haojiaId=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 跑步专区
    var runningRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/running$/i;
    if (runningRegExp.test(href)) {
      return href.replace(
        runningRegExp,
        "shihuo://www.shihuo.cn?route=running" + (mdStr ? "#%7B" + mdStr : "")
      );
    }
    var runningParamRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/running\?haojiaId=(\d+)$/i;
    if (runningParamRegExp.test(href)) {
      return href.replace(
        runningParamRegExp,
        "shihuo://www.shihuo.cn?route=running&haojiaId=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }
    // 休闲专区
    var freestyleRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/freestyle$/i;
    if (freestyleRegExp.test(href)) {
      return href.replace(
        freestyleRegExp,
        "shihuo://www.shihuo.cn?route=freestyle" + (mdStr ? "#%7B" + mdStr : "")
      );
    }
    var freestyleParamRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/freestyle\?haojiaId=(\d+)$/i;
    if (freestyleParamRegExp.test(href)) {
      return href.replace(
        freestyleParamRegExp,
        "shihuo://www.shihuo.cn?route=freestyle&haojiaId=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 健身专区
    var fitnessRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/fitness$/i;
    if (fitnessRegExp.test(href)) {
      return href.replace(
        fitnessRegExp,
        "shihuo://www.shihuo.cn?route=fitness" + (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 足球专区
    var footballRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/football$/i;
    if (footballRegExp.test(href)) {
      return href.replace(
        footballRegExp,
        "shihuo://www.shihuo.cn?route=football" + (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 数码专区
    var digitalRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/digital$/i;
    if (digitalRegExp.test(href)) {
      return href.replace(
        digitalRegExp,
        "shihuo://www.shihuo.cn?route=digital" + (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 理容专区
    var beautyRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/beauty$/i;
    if (beautyRegExp.test(href)) {
      return href.replace(
        beautyRegExp,
        "shihuo://www.shihuo.cn?route=beauty" + (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 商品详情
    var goodsDetailRegExpOne = /^https?:\/\/[www|m]+\.shihuo\.cn\/sports\/detail\/(\d+).html$/i;
    if (goodsDetailRegExpOne.test(href)) {
      return href.replace(
        goodsDetailRegExpOne,
        "shihuo://www.shihuo.cn?route=goodsDetail&id=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }
    // 商品详情
    var goodsDetailRegExpTwo = /^https?:\/\/[www|m]+\.shihuo\.cn\/sports\/detail\/(\d+).html\?(.+)$/i;
    if (goodsDetailRegExpTwo.test(href)) {
      return href.replace(
        goodsDetailRegExpTwo,
        "shihuo://www.shihuo.cn?route=goodsDetail&id=$1&$2" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 商品详情
    var goodsDetailRegExpOne = /^https?:\/\/[m-]+share+\.shihuo\.cn\/sports\/detail\/(\d+).html$/i;
    if (goodsDetailRegExpOne.test(href)) {
      return href.replace(
        goodsDetailRegExpOne,
        "shihuo://www.shihuo.cn?route=goodsDetail&id=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }
    // 商品详情
    var goodsDetailRegExpTwo = /^https?:\/\/[m-]+share+\.shihuo\.cn\/sports\/detail\/(\d+).html\?(.+)$/i;
    if (goodsDetailRegExpTwo.test(href)) {
      return href.replace(
        goodsDetailRegExpTwo,
        "shihuo://www.shihuo.cn?route=goodsDetail&id=$1&$2" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 商品详情
    var goodsDetailRegExpThree = /^https?:\/\/[m-]+share+\.shihuo\.cn\/app\/assets\/h5app\/ShihuoDetail.html\?(.+)$/i;
    if (goodsDetailRegExpThree.test(href)) {
      const goodsId = getUrlParams(href, 'goodsId');
      const styleId = getUrlParams(href, 'styleId');
      const skuId = getUrlParams(href, 'skuId');
      const device = getUrlParams(href, 'device');
      const platform = getUrlParam(href, 'platform');
      return href.replace(
        goodsDetailRegExpThree,
        `shihuo://www.shihuo.cn?route=goodsDetail&id=${goodsId}${styleId ? '&styleId=' + styleId : ''}${skuId ? '&skuId=' + skuId : ''}${device ? '&device=' + device : ''}${platform ? '&platform=' + platform : ''}` + 
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 优惠列表
    var youhuiListRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/youhui$/i;
    if (youhuiListRegExp.test(href)) {
      return href.replace(
        youhuiListRegExp,
        "shihuo://www.shihuo.cn?route=youhuiList" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }
    // 优惠详情
    var youhuiDetailRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/youhui\/(\d+).html(.*|\?.*)$/i;
    if (youhuiDetailRegExp.test(href)) {
      return href.replace(
        youhuiDetailRegExp,
        "shihuo://www.shihuo.cn?route=youhuiDetail&id=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 海淘首页
    var haitaoHomeRegExp;
    if (
      href.indexOf("www.shihuo.cn") > -1 ||
      href.indexOf("www.haitaodashi.cn") > -1
    ) {
      haitaoHomeRegExp = /^https?:\/\/www\.[shihuo|haitaodashi]+\.cn\/haitao$/i;
    } else if (href.indexOf("m.shihuo.cn") > -1) {
      haitaoHomeRegExp = /^https?:\/\/m\.shihuo\.cn\/haitao\/index$/i;
    }
    if (haitaoHomeRegExp && haitaoHomeRegExp.test(href)) {
      return href.replace(
        haitaoHomeRegExp,
        "shihuo://www.shihuo.cn?route=haitaoIndex" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 海淘列表
    var haitaoListRegExp;
    if (href.indexOf("www.shihuo.cn") > -1) {
      haitaoListRegExp = /^https?:\/\/www\.shihuo\.cn\/haitao\/youhui$/i;
    } else if (href.indexOf("m.shihuo.cn") > -1) {
      haitaoListRegExp = /^https?:\/\/m\.shihuo\.cn\/haitao$/i;
    }
    if (haitaoListRegExp && haitaoListRegExp.test(href)) {
      return href.replace(
        haitaoListRegExp,
        "shihuo://www.shihuo.cn?route=haitaoList" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }
    // 海淘详情
    var haitaoDetailRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/haitao\/youhui\/(\d+).html$/i;
    if (haitaoDetailRegExp.test(href)) {
      return href.replace(
        haitaoDetailRegExp,
        "shihuo://www.shihuo.cn?route=haitaoDetail&id=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 代购详情
    var daigouDetailRegExpOne;
    if (
      href.indexOf("www.shihuo.cn") > -1 ||
      href.indexOf("www.haitaodashi.cn") > -1
    ) {
      daigouDetailRegExpOne = /^https?:\/\/www\.[shihuo|haitaodashi]+\.cn\/haitao\/buy\/(\d+).html(.*|\?.*)$/i;
    } else if (href.indexOf("m.shihuo.cn") > -1) {
      daigouDetailRegExpOne = /^https?:\/\/m\.shihuo\.cn\/daigou\/(\d+).html(.*|\?.*)$/i;
    }
    if (daigouDetailRegExpOne && daigouDetailRegExpOne.test(href)) {
      return href.replace(
        daigouDetailRegExpOne,
        "shihuo://www.shihuo.cn?route=daigouDetail&pid=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 代购详情 ？
    var daigouDetailRegExpOneParam;
    if (href.indexOf("m.shihuo.cn") > -1) {
      daigouDetailRegExpOneParam = /^https?:\/\/m\.shihuo\.cn\/daigou\/(\d+).html(.*|\?.*)$/i;
    }
    if (daigouDetailRegExpOneParam && daigouDetailRegExpOneParam.test(href)) {
      return href.replace(
        daigouDetailRegExpOneParam,
        "shihuo://www.shihuo.cn?route=daigouDetail&pid=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 代购详情
    var daigouDetailRegExpTwo;
    if (
      href.indexOf("www.shihuo.cn") > -1 ||
      href.indexOf("www.haitaodashi.cn") > -1
    ) {
      daigouDetailRegExpTwo = /^https?:\/\/www\.[shihuo|haitaodashi]+\.cn\/haitao\/buy\/(\d+)-(\d+).html(.*|\?.*)$/i;
    } else if (href.indexOf("m.shihuo.cn") > -1) {
      daigouDetailRegExpTwo = /^https?:\/\/m\.shihuo\.cn\/daigou\/(\d+)-(\d+).html(.*|\?.*)$/i;
    }
    if (daigouDetailRegExpTwo && daigouDetailRegExpTwo.test(href)) {
      return href.replace(
        daigouDetailRegExpTwo,
        "shihuo://www.shihuo.cn?route=daigouDetail&pid=$1&gid=$2" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 现货详情
    var xianhuoDetailRegExpOne = /^https?:\/\/[www|m]+\.shihuo\.cn\/xianhuo\/buy\/(\d+).html$/i;
    if (xianhuoDetailRegExpOne.test(href)) {
      return href.replace(
        xianhuoDetailRegExpOne,
        "shihuo://www.shihuo.cn?route=daigouDetail&pid=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }
    // 现货详情
    var xianhuoDetailRegExpTwo = /^https?:\/\/[www|m]+\.shihuo\.cn\/xianhuo\/buy\/(\d+)-(\d+).html$/i;
    if (xianhuoDetailRegExpTwo.test(href)) {
      return href.replace(
        xianhuoDetailRegExpTwo,
        "shihuo://www.shihuo.cn?route=daigouDetail&pid=$1&gid=$2" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 团购列表
    var tuangouListRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/tuangou$/i;
    if (tuangouListRegExp.test(href)) {
      return href.replace(
        tuangouListRegExp,
        "shihuo://www.shihuo.cn?route=grouponHome" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }
    // 团购详情
    var tuangouDetailRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/tuangou\/(\d+)(.*|\?.*)$/i;
    if (tuangouDetailRegExp.test(href)) {
      return href.replace(
        tuangouDetailRegExp,
        "shihuo://www.shihuo.cn?route=grouponDetail&id=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 运动鞋列表
    var shoeListRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/shoe$/i;
    if (shoeListRegExp.test(href)) {
      return href.replace(
        shoeListRegExp,
        "shihuo://www.shihuo.cn?route=shoesList" + (mdStr ? "#%7B" + mdStr : "")
      );
    }
    // 运动鞋详情
    var shoeDetailRegExp;
    if (href.indexOf("www.shihuo.cn") > -1) {
      shoeDetailRegExp = /^https?:\/\/www\.shihuo\.cn\/detail\/(\d+).html$/i;
    } else if (href.indexOf("m.shihuo.cn") > -1) {
      shoeDetailRegExp = /^https?:\/\/m\.shihuo\.cn\/shoe\/detail\/(\d+).html$/i;
    }
    if (shoeDetailRegExp && shoeDetailRegExp.test(href)) {
      return href.replace(
        shoeDetailRegExp,
        "shihuo://www.shihuo.cn?route=shoesDetail&id=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 晒物列表
    var shaiwuListRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/shaiwu$/i;
    if (shaiwuListRegExp.test(href)) {
      return href.replace(
        shaiwuListRegExp,
        "shihuo://www.shihuo.cn?route=shaiwuList" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }
    // 晒物详情
    var shaiwuDetailRegExp;
    if (href.indexOf("www.shihuo.cn") > -1) {
      shaiwuDetailRegExp = /^https?:\/\/www\.shihuo\.cn\/shaiwu\/detail\/(\d+).html$/i;
    } else if (href.indexOf("m.shihuo.cn") > -1) {
      shaiwuDetailRegExp = /^https?:\/\/m\.shihuo\.cn\/shaiwu\/detail\/(\d+)(.*|\?.*)$/i;
    }
    if (shaiwuDetailRegExp && shaiwuDetailRegExp.test(href)) {
      return href.replace(
        shaiwuDetailRegExp,
        "shihuo://www.shihuo.cn?route=shaiwuDetail&id=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 优惠券列表
    var couponListRegExp;
    if (href.indexOf("www.shihuo.cn") > -1) {
      couponListRegExp = /^https?:\/\/www\.shihuo\.cn\/coupons\/quan$/i;
    } else if (href.indexOf("m.shihuo.cn") > -1) {
      couponListRegExp = /^https?:\/\/m\.shihuo\.cn\/coupon$/i;
    }
    if (couponListRegExp && couponListRegExp.test(href)) {
      return href.replace(
        couponListRegExp,
        "shihuo://www.shihuo.cn?route=myWallet" + (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 我的优惠券列表
    var myCouponListRegExp;
    if (href.indexOf("www.shihuo.cn") > -1) {
      myCouponListRegExp = /^https?:\/\/www\.shihuo\.cn\/ucenter\/myCoupon$/i;
    }
    if (myCouponListRegExp && myCouponListRegExp.test(href)) {
      return href.replace(
        myCouponListRegExp,
        "shihuo://www.shihuo.cn?route=myCoupon" + (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 优惠券详情
    var couponDetailRegExp;
    if (href.indexOf("www.shihuo.cn") > -1) {
      couponDetailRegExp = /^https?:\/\/www\.shihuo\.cn\/duihuan\/(\w+).html$/i;
    } else if (href.indexOf("m.shihuo.cn") > -1) {
      couponDetailRegExp = /^https?:\/\/m\.shihuo\.cn\/coupon\/(\w+).html$/i;
    }
    if (couponDetailRegExp && couponDetailRegExp.test(href)) {
      return href.replace(
        couponDetailRegExp,
        "shihuo://www.shihuo.cn?route=youhuiquanDetail&id=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 文章详情
    var articleDetailRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/article\/detail\/(\d+).html(.*|\?.*)$/i;
    if (articleDetailRegExp.test(href)) {
      return href.replace(
        articleDetailRegExp,
        "shihuo://www.shihuo.cn?route=articleDetail&id=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 栏目列表
    var columnListRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/column\/(\d+).html(.*|\?.*)$/i;
    if (columnListRegExp.test(href)) {
      return href.replace(
        columnListRegExp,
        "shihuo://www.shihuo.cn?route=columnHome&id=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 活动列表
    var activityListRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/activity\/(\d+).html(.*|\?.*)$/i;
    if (activityListRegExp.test(href)) {
      return href.replace(
        activityListRegExp,
        "shihuo://www.shihuo.cn?route=activityHome&id=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    if (
      0 === href.indexOf("http://item.taobao.com/item.htm") ||
      0 === href.indexOf("http://detail.tmall.com/item.htm") ||
      0 === href.indexOf("https://detail.m.tmall.com/item.htm") ||
      0 === href.indexOf("https://item.taobao.com/item.htm") ||
      0 === href.indexOf("https://detail.tmall.com/item.htm") ||
      0 === href.indexOf("http://detail.tmall.hk/hk/item.htm") ||
      0 === href.indexOf("https://detail.tmall.hk/hk/item.htm") ||
      0 === href.indexOf("https://h5.m.taobao.com/awp/core/detail.htm") ||
      0 === href.indexOf("http://h5.m.taobao.com/awp/core/detail.htm") ||
      0 === href.indexOf("https://s.click.taobao.com") ||
      0 === href.indexOf("http://s.click.taobao.com") ||
      0 === href.indexOf("https://g.click.taobao.com") ||
      0 === href.indexOf("http://g.click.taobao.com") || 
      0 === href.indexOf("https://market.m.taobao.com") || 
      0 === href.indexOf("https://uland.taobao.com") || 
      0 === href.indexOf("https://u.jd.com") ||
      0 === href.indexOf("https://pages.tmall.com") ||
      (0 === href.indexOf("http") && new URL(href).host.indexOf('shihuo') === -1)
    ) {
      return (
        "shihuo://www.shihuo.cn?route=go&url=" +
        encodeURIComponent(href) +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    //专题地址转换
    var specialRegExp = /^https?:\/\/t\.shihuo\.cn\/(\d+).html$/i;
    var specialMRegExp = /^https?:\/\/t\.shihuo\.cn\/m\/(\d+).html$/i;
    if (specialRegExp && specialRegExp.test(href)) {
      return href.replace(
        specialRegExp,
        "http://t.shihuo.cn/app/$1.html" + (mdStr ? "#%7B" + mdStr : "")
      );
    }
    if (specialMRegExp && specialMRegExp.test(href)) {
      return href.replace(
        specialMRegExp,
        "http://t.shihuo.cn/app/$1.html" + (mdStr ? "#%7B" + mdStr : "")
      );
    }

    //栏目活动详情
    var pictureDetailRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/picture\/detail\/(\d+).html(.*|\?.*)$/i;
    if (pictureDetailRegExp.test(href)) {
      return href.replace(
        pictureDetailRegExp,
        "shihuo://www.shihuo.cn?route=pictureDetail&id=$1" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 装备集合页
    var goodsTabRegExp = /^https?:\/\/m\.shihuo\.cn\/zhuangbei$/i;
    if (goodsTabRegExp.test(href)) {
      return href.replace(
        goodsTabRegExp,
        "shihuo://www.shihuo.cn?route=zoneHomes" + (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 发现首页
    var findHomeRegExp = /^https?:\/\/m\.shihuo\.cn\/find\/index$/i;
    if (findHomeRegExp.test(href)) {
      return href.replace(
        findHomeRegExp,
        "shihuo://www.shihuo.cn?route=shiwuHome" + (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 推荐店铺
    var recommendShopRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/shop$/i;
    if (recommendShopRegExp.test(href)) {
      return href.replace(
        recommendShopRegExp,
        "shihuo://www.shihuo.cn?route=shop" + (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 优惠列表
    var baicaiListRegExp = /^https?:\/\/[www|m]+\.shihuo\.cn\/baicai$/i;
    if (baicaiListRegExp.test(href)) {
      return href.replace(
        baicaiListRegExp,
        "shihuo://www.shihuo.cn?route=baicaiList" +
        (mdStr ? "#%7B" + mdStr : "")
      );
    }

    // 以上都无法匹配
    return href + (mdStr ? "#%7B" + mdStr : "");
  } else {
    return href;
  }
}

// 复制内容到剪贴板，此函数必须在点击事件或者其他事件中执行，不然无效
function copyToClipBoard(copyText) {
  clipboardCopy(copyText);
}

// 解析特定序列化字符串
function parseQueryStringParams(queryString, key) {
  var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
  var r = queryString.match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
function isJSON(str) {
  if (typeof str == "string") {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  }
}

function isIphoneX() {
  return (
    !isAndroid() && (
      (window.screen.width === 375 && window.screen.height === 812) ||
      (window.screen.width === 414 && window.screen.height === 896) ||
      (window.screen.width === 390 && window.screen.height === 844) ||
      (window.screen.width === 428 && window.screen.height === 926)
    )
  );
}

function isIphone14ProMax() {
  return (
    !isAndroid() && (
      (window.screen.width === 393 && window.screen.height === 852) ||
      (window.screen.width === 402 && window.screen.height === 874) ||
      (window.screen.width === 420 && window.screen.height === 912) ||
      (window.screen.width === 430 && window.screen.height === 932) ||
      (window.screen.width === 440 && window.screen.height === 956)
    )
  );
}

function getQueryVariable(variable, query) {
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return {};
}
function getTPExtra(tpExtra) {
  if (typeof tpExtra == "string" && tpExtra) {
    tpExtra = decodeURIComponent(tpExtra) || {};
  }
  if (tpExtra) {
    if (isJSON(tpExtra)) {
      tpExtra = JSON.parse(tpExtra);
    }
    tpExtra = {
      ...tpExtra,
      ffTp: tpExtra.fTp || "",
      ffTpName: tpExtra.fTpName || "",
    };
    return tpExtra;
  } else {
    return {};
  }
}
function formatTPExtraData(str, tpExtra, index = "") {
  const pathname = window.location.pathname;
  const firstIndex = pathname.indexOf("page/");
  const lastIndex = pathname.indexOf("/index.html");
  let id = "";
  if (firstIndex > -1 && lastIndex > -1 && firstIndex != lastIndex) {
    id = pathname.substring(firstIndex + 5, lastIndex) || "";
  }
  console.log("id", id);
  let tempTPExtra = tpExtra || {};
  if (typeof str == "string" && str) {
    let formatStr = decodeURIComponent(str) || {};
    isJSON(formatStr)
      ? ((formatStr = JSON.parse(formatStr) || {}),
        (tempTPExtra.fTp =
          formatStr && formatStr.block ? formatStr.block + "_" + id : "_" + id),
        (tempTPExtra.fTpName = "专题_" + id),
        (tempTPExtra = JSON.stringify(tempTPExtra)))
      : (tempTPExtra = encodeURIComponent(tempTPExtra));
    return encodeURIComponent(tempTPExtra);
  } else {
    tempTPExtra.fTp = "_" + id;
    tempTPExtra.fTpName = "专题_" + id;
    return encodeURIComponent(JSON.stringify(tempTPExtra));
  }
}
function jumpToUrl(
  value,
  url = "",
  hashStringUrl = "",
  options = {},
  id = -1,
  data = {},
  hasCombine = true,
  ptiOptions = {},
  otherTpExtra = {},
  formatUrl = true
) {
  url = url.trim();
  let productUrl =  formatUrl ? url.split("#")[0] : url;
  const hashString =
    hashStringUrl.indexOf("#") > -1 ? hashStringUrl.split("#")[1] : "";
  let pageId = getPageId();
  id = id == -1 ? pageId : id;
  options.block = data ? data.customAttributes["data-component-block"] : "";
  options.from = `shihuo://www.shihuo.cn?route=RNProgram&miniId=Shihuo_SpecialTopics&page=ShoesSpecialShows&options=${encodeURIComponent(
    JSON.stringify({ id: pageId })
  )}`;
  options.extra = { from: options.from, block: options.block };
  try {
    if (hashString && hasCombine) {
      const oldOptions = JSON.parse(decodeURIComponent(hashString));
      options = {
        ...oldOptions,
        ...options
      }
      // 数据合并
      // Object.assign(options, oldOptions);
    }
  } catch (error) { }

  if (isShihuo()) {
    let tpExtra = {};
    // console.log("value", value, productUrl);
    if (value) {
      const obj = typeof value == "string" ? JSON.parse(value) : value;
      tpExtra = obj && obj.tpExtra ? obj.tpExtra : {};
    }
    tpExtra = getTPExtra(tpExtra);
    if (otherTpExtra) {
      Object.assign(tpExtra, otherTpExtra)
    }
    if (ptiOptions && ptiOptions.id) {
      // 追加sourceTp
      Object.assign(tpExtra, {
        sourceTp: ptiOptions.id,
        sourceTpName: ptiOptions.tpName,
      });
    }
    // console.log(
    //   "tpExtra=AB1==",
    //   tpExtra,
    //   "tpExtra",
    //   JSON.stringify(tpExtra)
    // );
    // console.log("hashString", hashString, "productUrl", productUrl);
    const newTPExtra = formatTPExtraData(
      encodeURIComponent(JSON.stringify(options)),
      tpExtra,
      id
    );
    // console.log("newTPExtra", newTPExtra, "item.id", id);
    let link = productUrl;

    if (formatUrl) {
      if (productUrl.includes("?")) {
        link = `${productUrl}&tpExtra=${newTPExtra}#${encodeURIComponent(
          JSON.stringify(options)
        )}`;
      } else {
        link = `${productUrl}?tpExtra=${newTPExtra}#${encodeURIComponent(
          JSON.stringify(options)
        )}`;
      }
    }

    // 站外链接转换为识货路由
    if (!productUrl.includes("shihuo.cn")) {
      link = `shihuo://www.shihuo.cn?route=fastWebview&url=${encodeURIComponent(
        productUrl
      )}&tpExtra=${newTPExtra}#${encodeURIComponent(JSON.stringify(options))}`;
    }

    console.log("跳转链接", link, "tpExtra", JSON.stringify(tpExtra));

    if (getParams('community_tab') == '1') {
      localStorage.setItem('jumpSubPage', '1');
    }
    // 跳转及埋点上报
    navigateWithTrack(link, data, pageId, options, ptiOptions);

  } else {
    if (window.HW_MANAGED_JS || (window.lives && typeof window.lives.getAppExists == 'function')) {
      // 如果是在华为智慧搜素或华为生活服务App打开
      productUrl = formatRouteToH5(productUrl);
    }
    const link = `${productUrl}#${encodeURIComponent(JSON.stringify(options))}`;
    console.log("跳转链接", link);
    // 跳转及埋点上报
    navigateWithTrack(link, data, pageId, options, ptiOptions);
  }
}
function handleToufangClick({
  link,
  props,
  index,
  clickType
}) {
  link = link.trim();
  const longurl = getParams('longurl');
  if (longurl) {
    const from = getUrlParams(longurl, 'from');
    // 当前页面是B站投放页面时，给link设置默认值，页面所有热区点击都可进行场景还原
    if (['kiwi-release-signed-shihuo', 'kiwi-release-signed-bilibili'].indexOf(from) >= 0) {
      link = 'http://www.shihuo.cn';
    }
  }
  const compName = props.customAttributes["data-component-name"]
  const shouldRedirect = link && ['pipeline-image', 'pipeline-imgList', 'pipeline-imgHotMap', 'pipeline-lottery'].includes(compName)

  const { downloadUrl = "", from = "", kouling = "" } = props;
  const block = props.customAttributes["data-component-block"]
  let app_link = link;
  let pageId = getPageId();
  let options = decodeURIComponent(getUrlParam(link, "options"));
  let optionsProps = {
    sort: index
  }
  if (options) {
    options = JSON.parse(options);
    options = Object.assign({}, options, {
      from: from,
      block: block,
      sort: index
    })
    options = "&options=" + encodeURIComponent(JSON.stringify(options));
    const link_url = removeURLParameter(link, "options");
    app_link = link_url + options;
  }

  if (isShihuo()) {
    window.__dace.sendEvent(`${from}_h5_${block}_index${index}`);
    app_link = convertHref(app_link);
    app_link = app_link + "#" + encodeURIComponent(`{"from": "${from}","block":"h5_${block}_index${index}","index":"${index}"}`)
    // 跳转及埋点上报
    navigateWithTrack(app_link, props, pageId, optionsProps);
  } else {

    uploadTrack(props, optionsProps);
    uploadTrack(props, optionsProps, {
      ptiId: `${props.templatePti}:beginDownload`,
      bizExtra: {
        kouling: kouling,
        ua: navigator.userAgent,
        downloadUrl: downloadUrl
      }
    });

    this.checkOpen(() => {
      // 唤端成功的回调
      // 唤端成功埋点
      const ptiOptions = {
        ptiId: `${props.templatePti}:arouseSuss`,
        bizExtra: {
          kouling: kouling,
          ua: navigator.userAgent,
          downloadUrl: downloadUrl
        }
      }
      uploadTrack(props, optionsProps, ptiOptions);
    }, () => {
      // 唤端失败的回调
      // 唤端失败埋点
      uploadTrack(props, optionsProps, {
        ptiId: `${props.templatePti}:arouseFail`,
        bizExtra: {
          kouling: kouling,
          ua: navigator.userAgent,
          downloadUrl: downloadUrl
        }
      });

      // 唤端失败，跳转下载埋点
      uploadTrack(props, optionsProps, {
        ptiId: `${props.templatePti}:endDownload`,
        bizExtra: {
          kouling: kouling,
          ua: navigator.userAgent,
          downloadUrl: downloadUrl
        }
      });

      if (isAndroid()) {
        androidDownload(props);
      }

    }, () => {
      // 唤端捕获异常的回调
      if (isAndroid()) {
        androidDownload(props);
      }
    })

    // 如果有口令，将口令复制到剪贴板，同时将跳转link改为首页
    if (kouling) {
      const m_device_id = window.localStorage.getItem('m_device_id') || '';
      m_device_id ? copyToClipBoard(`${kouling}##${m_device_id}##`) : copyToClipBoard(kouling);
      link = `shihuo://www.shihuo.cn?route=convert&navigationBar=false&tl=replace_kl&url=${encodeURIComponent(`https://zt-public.shihuo.cn/page/9999/index.html?kl=${kouling}&device_id=${m_device_id}&tl=replace_kl`)}`;
    }

    if (!shouldRedirect) {
      return
    }

    // 复制口令动作异步执行，后续跳转放在异步回调中
    setTimeout(() => {
      if (isAndroid()) {
        window.location.href = link;
      } else {
        const href = `https://m.shihuo.cn/api/transit?source=${encodeURIComponent(link)}&target=${encodeURIComponent(downloadUrl)}`;
        window.location.href = href;
      }
    }, 40);

  }
}
// 投放页面安卓下载
function androidDownload(props) {
  const { downloadUrl = '', from = '', abTestEnable = '', legoAb = '' } = props;
  if (from !== 'kuaishou') {
    // 非快手（如抖音、B站）投放页下载
    window.location.href = downloadUrl;
  } else {
    // 快手投放页下载
    if (abTestEnable === '否' || (abTestEnable === '是' && legoAb === 'B')) {
      window.location.href = "vivomarket://details?id=com.hupu.shihuo"  // vivo应用商店
      window.location.href = "oppomarket://details?packagename=com.hupu.shihuo"  // oppo应用商店
      window.location.href = "appmarket://details?id=com.hupu.shihuo"  // 华为应用商店
      window.location.href = "mimarket://details?id=com.hupu.shihuo"  // 小米应用商店
      window.location.href = "samsungapps://ProductDetail/com.hupu.shihuo"  // 三星应用商店
      window.location.href = "mstore://details?package_name=com.hupu.shihuo"  // 魅族应用商店

      checkOpen(() => {
        // 跳转应用商店成功
      }, () => {
        // 跳转应用商店失败
        window.location.href = downloadUrl;
      }, () => {
        // 跳转应用商店失败
        window.location.href = downloadUrl;
      }, 1000)
    } else {
      window.location.href = downloadUrl
    }
  }
}
function getIphoneUrl(downloadUrl) {
  var searchString = downloadUrl.split('?')[1] || '';
  var queryObj = {};
  searchString.split('&').forEach(item => {
    var itemObj = item.split('=');
    queryObj[itemObj[0]] = decodeURIComponent(itemObj[1]);
  });
  return queryObj.iphone_url || '';
}

function getUrlParam(url, paraName) {
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split("&");
    var arr;

    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] === paraName) {
        return arr[1];
      }
    }
    return "";
  }
  else {
    return "";
  }
}

function removeURLParameter(url, parameter) {
  var urlparts = url.split('?');
  if (urlparts.length >= 2) {
    //参数名前缀
    var prefix = encodeURIComponent(parameter) + '=';
    var pars = urlparts[1].split(/[&;]/g);

    //循环查找匹配参数
    for (var i = pars.length; i-- > 0;) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        //存在则删除
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}
function getWeightRandom(arr) {
  var total = 0;
  var i, j, percent;
  //下标标记数组
  var index = new Array();
  for (i = 0; i < arr.length; i++) {
    //判断元素的权重，为了实现小数权重，先将所有的值放大100倍
    percent =
      "undefined" != typeof arr[i].percent ? parseInt(arr[i].percent * 100) : 0;
    for (j = 0; j < percent; j++) {
      index.push(i);
    }
    total += percent;
  }
  //随机数值
  var rand = Math.floor(Math.random() * total);
  return arr[index[rand]];
}

function getPageId() {
  if (typeof window === "undefined") {
    return '';
  }
  let pageId;
  const h5Url = window.location.href;
  if (h5Url.indexOf('offlineWeb/page') < 0) {
    // 正在加载获取页面ID
    const splitUrl = window.location.pathname.split('/');
    if (['lego-api.shihuo.cn', 'lego-api-tst.shihuo.cn'].indexOf(window.location.host) >= 0) {
      pageId = splitUrl[splitUrl.length - 4];
    } else {
      pageId = splitUrl[splitUrl.length - 2];
    }
  } else {
    // 离线包加载获取页面ID
    const match = h5Url.match(/page\/(\d+)\/version/); 
    if (match) {
      pageId = match[1];
    } else {
      pageId = '';
    }
  }
  return pageId;
}

function toast(content = '', time = 3000) {
  // 新增一个toast弹窗
  if (typeof window !== 'undefined') {
    const toastEl = document.createElement('div');
    toastEl.innerText = content;
    toastEl.classList.add('global-toast');
    document.body.appendChild(toastEl);
    setTimeout(() => {
      toastEl.remove();
    }, time);
  }
}

// 获取版本号
function getVersion() {
  if (typeof window === "undefined") {
    return '';
  }
  var UA = navigator.userAgent,
    reg = /\s(shihuo\/.*?)\s/;

  var match = reg.exec(UA),
    version = match ? match[1].split('/')[1] : null;

  return version;
}

// 版本号大小比较
function SHDiffVersion(ver1, ver2) {
  if (!ver1 || !ver2) {
    return null
  }
  var ver1Arr = ver1.split('.');
  var ver2Arr = ver2.split('.');

  var minL = Math.min(ver1Arr.length, ver2Arr.length);

  var diffRes = 0;
  var i = 0;
  while (i < minL) {
    diffRes = parseInt(ver1Arr[i]) - parseInt(ver2Arr[i])
    if (diffRes != 0) {
      break;
    }
    i++;
  }

  return diffRes >= 0;
}

function formatImgUrl(url = '', webpSupport = false, type = '') {
  if (url.indexOf('.webp') >= 0) {
    return url;
  }

  let formatUrl = '';
  if (webpSupport) {
    if (url.indexOf('.gif') < 0) {
      if (type === 'card') {
        formatUrl = `${url}?imageView2/0/w/376/interlace/1/format/webp/avif/ignore-error/1`;
      } else {
        formatUrl = `${url}?imageView2/0/interlace/1/format/webp/avif/ignore-error/1`;
      }
    } else {
      formatUrl = url;
    }
  } else {
    formatUrl = `${url}?imageslim/zlevel/1|imageMogr2/interlace/1/avif/ignore-error/1`;
  }

  return formatUrl;
}

// 跳转埋点
function navigateWithTrack(link, props = {}, pageId, options = {}, ptiOptions = {}) {
  const { templatePti, customAttributes, legoAb = '', kouling } = props;
  const tabChName = props.tabChName || window.sessionStorage.getItem('tabChName');
  const compName = customAttributes["data-component-name"].replace(/pipeline-/, '');
  const blockName = ptiOptions.blockName ? `-${ptiOptions.blockName}` : "";
  const from = ptiOptions.from || options.from;
  const block = ptiOptions.block || options.block;
  const PtiIDPosition = typeof options.sort === 'number' ? String(options.sort) : null;
  const { sort, goods_id, style_id } = options;
  const componentBlockArr = customAttributes["data-component-block"].split('-');
  //TODO biz 的扩展字段
  const { bizExtra = {} } = ptiOptions || {};
  const ptiBizOptions = {
    pageId,
    goods_id,
    style_id,
    sort,
    legoAb,
    kouling,
    lego_page_id: pageId,
    component_id: customAttributes['data-component-id'],
    tabChName,
    ua: navigator.userAgent,
    ...bizExtra
  }

  let ptiId = '', ptiName = '';
  if (!ptiOptions.ptiId) {
    ptiId = !PtiIDPosition ? `${templatePti}:${compName}${blockName}` : `${templatePti}:${compName}${blockName}:${PtiIDPosition}`
  } else {
    ptiId = ptiOptions.ptiId
  }
  if (!ptiOptions.ptiName) {
    ptiName = componentBlockArr[componentBlockArr.length - 1].split('_')[0];
  } else {
    ptiName = ptiOptions.ptiName
  }

  shihuo.navigateWithTrack({
    url: link,
    pageOptions: {
      from,
      block,
      from_sort: PtiIDPosition,
      legoAb,
      kouling,
      lego_page_id: pageId,
      tabChName,
      ua: navigator.userAgent,
      ...ptiOptions,
      ...bizExtra
    },
    pti: {
      id: ptiId,
      name: ptiName,
      pageId,
      biz: JSON.stringify(ptiBizOptions),
      pageOptions: {
        lego_page_id: pageId,
        tabChName,
        legoAb,
        kouling,
        ...bizExtra
      }
    }
  })

}

// 点击埋点
function uploadTrack(props = {}, options = {}, ptiOptions = {}) {
  const { kouling = '', source = '' } = props;
  const templatePti = props.templatePti;
  const tabChName = props.tabChName || window.sessionStorage.getItem('tabChName');
  const legoAb = props.legoAb;
  const compName = props.customAttributes["data-component-name"].replace(/pipeline-/, '');
  const blockName = ptiOptions.blockName ? `-${ptiOptions.blockName}` : "";
  const ptiIdPosition = typeof options.sort === 'number' ? String(options.sort) : null;
  const componentBlockArr = props.customAttributes["data-component-block"].split('-');
  //TODO biz 的扩展字段
  const { bizExtra = {} } = ptiOptions || {};
  const pageOptions = {
    legoAb,
    lego_page_id: getPageId(),
    component_id: props.customAttributes['data-component-id'],
    tabChName,
    ua: navigator.userAgent,
    kouling,
    source,
    ...bizExtra
  }

  let ptiId = '', ptiName = '';
  if (!ptiOptions.ptiId) {
    ptiId = `${templatePti}:${compName}${blockName}${ptiIdPosition ? (':' + ptiIdPosition) : ''}`
  } else {
    ptiId = ptiOptions.ptiId
  }
  if (!ptiOptions.ptiName) {
    ptiName = componentBlockArr[componentBlockArr.length - 1].split('_')[0];
  } else {
    ptiName = ptiOptions.ptiName
  }

  shihuo.uploadTrack({
    pti: {
      id: ptiId,
      name: ptiName,
      biz: JSON.stringify(pageOptions),
      pageOptions
    }
  })
}

// 曝光埋点字段信息
function getExposureData(props = {}, options = {}, ptiOptions = {}) {
  const pageId = getPageId();
  const { templatePti, customAttributes, legoAb = '', kouling } = props;
  const tabChName = props.tabChName || window.sessionStorage.getItem('tabChName');
  const compName = customAttributes["data-component-name"].replace(/pipeline-/, '');
  const blockName = ptiOptions.blockName ? `-${ptiOptions.blockName}` : "";
  const PtiIDPosition = typeof options.sort === 'number' ? String(options.sort) : null;
  const { sort, goods_id, style_id } = options;
  const componentBlockArr = customAttributes["data-component-block"].split('-');
  //TODO biz 的扩展字段
  const { bizExtra = {} } = ptiOptions || {};
  const biz = {
    pageId,
    goods_id,
    style_id,
    sort,
    legoAb,
    kouling,
    lego_page_id: pageId,
    component_id: customAttributes['data-component-id'],
    tabChName,
    ua: navigator.userAgent,
    ...bizExtra
  }
  let ptiId = '', ptiName = '';
  if (!ptiOptions.ptiId) {
    ptiId = !PtiIDPosition ? `${templatePti}:${compName}${blockName}` : `${templatePti}:${compName}${blockName}:${PtiIDPosition}`
  } else {
    ptiId = ptiOptions.ptiId
  }
  if (!ptiOptions.ptiName) {
    ptiName = componentBlockArr[componentBlockArr.length - 1].split('_')[0];
  } else {
    ptiName = ptiOptions.ptiName
  }

  return {
    id: ptiId,
    name: '',
    biz: JSON.stringify(biz),
    exposekey: ptiId
  }
}

// 获取识货App商详页路由参数
function getGoodsDetailRouteParams(url) {
  const routeUrl = url.split('#')[0];
  let routeParams = {};
  if (routeUrl.indexOf('?route=goodsDetail') >= 0) {
    let query = routeUrl.split('?')[1];
    query = query.split('&');
    for (let i = 0; i < query.length; i++) {
      const q = query[i].split('=');
      if (q.length === 2 && q[0] !== 'route') {
        routeParams[q[0]] = q[1]
      }
    }
  }
  return routeParams;
}

// 将识货App商详页路由转成华为H5商详页地址
function formatRouteToH5(url) {
  if (url.indexOf('shihuo://www.shihuo.cn?route=goodsDetail') >= 0) {
    const routeParams = getGoodsDetailRouteParams(url);
    const { detailRouteType = '', id = '', styleId = '' } = routeParams;
    const h5Url = `https://m.shihuo.cn/app/assets/h5app/SkuDetail.html?detail_route_type=${detailRouteType}&goods_id=${id}&style_id=${styleId}`;
    return h5Url;
  } else {
    return url;
  }
}

// 将组件尺寸发送消息给后台编辑器
function postComponentSizeToEditor() {
  if (typeof window !== 'undefined' && window.parent && iframe) {
    try {
      window.onload = () => {
        setTimeout(() => {
          const pipelineSize = SyncComponentsSize(null, []);
          console.log('获取组件宽高发送给后台编辑器', pipelineSize);
          window.parent.postMessage && window.parent.postMessage({
            msgType: 'pageLoadComplete',
            pipelineSize
          }, '*');
          postPictureSizes();
        }, 2000);
      }
    } catch (err) {
      console.log(err);
    }
  }
}

// 同步组件尺寸配置（主要针对页面里同步渲染的组件，不包含通过异步获取数据再渲染的组件）
function SyncComponentsSize(targetNote, pipelineSize = []) {
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  let targetNoteChilds = null;
  if (!targetNote) {
    const iFrameRoot = document.querySelector('#root');
    const iFrameRootApp = iFrameRoot && iFrameRoot.children[0];
    targetNoteChilds = iFrameRootApp && iFrameRootApp.childNodes;
  } else {
    targetNoteChilds = targetNote.childNodes;
  }

  if (!targetNoteChilds || (targetNoteChilds && targetNoteChilds.length <= 0)) {
    return;
  }

  for (let index = 0; index < targetNoteChilds.length; index++) {
    const pipelineTarget =
      targetNoteChilds[index].getAttribute('data-component-id')
        ? targetNoteChilds[index]
        : (targetNoteChilds[index].childNodes && targetNoteChilds[index].childNodes[0]);
    if (pipelineTarget) {
      const componentName = pipelineTarget.getAttribute('data-component-name');
      const componentId = pipelineTarget.getAttribute('data-component-id');
      let childNoteSizeList = [];
      let adaptNoteSize = {}
      if (['pipeline-imgList', 'pipeline-imgHotMap', 'pipeline-product', 'pipeline-productLayout3', 'pipeline-rank'].indexOf(componentName) >= 0) {
        childNoteSizeList = getAllImageContainNote(componentName, pipelineTarget);
        adaptNoteSize = getCompAdaptNodeSize(componentName, pipelineTarget);
      }
      if (componentId && componentId.indexOf('pipeline-tab-') >= 0) {
        const tabNav = pipelineTarget.querySelector('.tab-nav');
        const tabContent = pipelineTarget.querySelector('.tab-content');
        if (tabNav) {
          // 将Tab组件中Tab切换栏的尺寸进行记录保存
          const pipelineComps = {
            id: componentId,
            size: {
              width: String(getStyle(tabNav, 'width')),
              height: String(getStyle(tabNav, 'height')),
              delayLoad: tabNav.offsetTop > windowHeight ? true : false  // 标记非首屏的组件，用于延迟加载
            },
            childNoteSizeList,
            adaptNoteSize
          }
          pipelineSize.push(pipelineComps);
        }
        if (tabContent) {
          for (let index = 0; index < tabContent.childNodes.length; index++) {
            const targetNote = tabContent.childNodes[index];
            SyncComponentsSize(targetNote, pipelineSize)
          }
        }
      } else {
        pipelineTarget.style.minHeight = 0;  // 每次页面渲染完成后，先将渲染后组件minHeight置为0，防止后续获取组件高度时获取的是上一次的minHeight高度
        const pipelineComps = {
          id: componentId,
          size: {
            width: String(getStyle(pipelineTarget, 'width')),
            height: String(getStyle(pipelineTarget, 'height')),
            delayLoad: pipelineTarget.offsetTop > windowHeight ? true : false  // 标记非首屏的组件，用于延迟加载
          },
          childNoteSizeList,
          adaptNoteSize
        }
        pipelineSize.push(pipelineComps)  // 遍历拿到页面中的组件及组件尺寸 
      }
    }
  }
  return pipelineSize
}

// 同步组件尺寸配置（主要针对异步获取完数据再渲染的组件）
function SyncComponentsSizeAsync(pipelineTarget) {
  if (pipelineTarget) {
    pipelineTarget.style.minHeight = 0;  // 每次页面渲染完成后，先将渲染后组件minHeight置为0，防止后续获取组件高度时获取的是上一次的minHeight高度
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const componentId = pipelineTarget.getAttribute('data-component-id');
    const pipelineSize = {
      id: componentId,
      size: {
        width: String(getStyle(pipelineTarget, 'width')),
        height: String(getStyle(pipelineTarget, 'height')),
        delayLoad: pipelineTarget.offsetTop > windowHeight ? true : false  // 标记非首屏的组件，用于延迟加载
      }
    }
    console.log('异步加载的组件尺寸', pipelineSize)
    window.parent.postMessage && window.parent.postMessage({
      msgType: 'componentLoadComplete',
      pipelineSize
    }, '*');
  }
}

// 获取图片组件和热区组件中所有图片容器节点
function getAllImageContainNote(componentName, parentNode) {
  let allImageNotes = null, childNoteSizeList = [];
  if (componentName === 'pipeline-imgList') {
    allImageNotes = parentNode.querySelectorAll('.img-item');
  }
  if (allImageNotes && allImageNotes.length > 0) {
    for (let index = 0; index < allImageNotes.length; index++) {
      const childNote = allImageNotes[index];
      if (childNote) {
        const childNoteImg = childNote.querySelector('img');
        if (childNoteImg) {
          const childNoteSize = {
            width: String(getStyle(childNoteImg, 'width')),
            height: String(getStyle(childNoteImg, 'height'))
          }
          childNoteSizeList.push(childNoteSize)
        }
      }
    }
  }
  return childNoteSizeList;
}

// 获取组件中自适应元素节点的尺寸
function getCompAdaptNodeSize(componentName, componentNode) {
  const adaptNodeSize = {}
  if (componentName === 'pipeline-product') {
    const imageTitle = componentNode.querySelector('.title-image') || componentNode.querySelector('.product-banner');
    if (imageTitle) {
      const titleImageSize = {
        width: String(getStyle(imageTitle, 'width')),
        height: String(getStyle(imageTitle, 'height'))
      }
      adaptNodeSize['titleImageSize'] = titleImageSize;
    } else {
      adaptNodeSize['titleImageSize'] = {
        width: '',
        height: ''
      };
    }
  } else if (componentName === 'pipeline-productLayout3') {
    // 商品组件一行三里，图片标题和图片Tab是自适应高度的元素，需要预取这两个元素的渲染高度
    const imageTitle = componentNode.querySelector('.title-image');
    const imageTab = componentNode.querySelector('.image-tab');
    if (imageTitle) {
      const titleImageSize = {
        width: String(getStyle(imageTitle, 'width')),
        height: String(getStyle(imageTitle, 'height'))
      }
      adaptNodeSize['titleImageSize'] = titleImageSize;
    } else {
      adaptNodeSize['titleImageSize'] = {
        width: '',
        height: ''
      };
    }
    if (imageTab) {
      const tabSize = {
        width: String(getStyle(imageTab, 'width')),
        height: String(getStyle(imageTab, 'height'))
      }
      adaptNodeSize['tabSize'] = tabSize;
    } else {
      adaptNodeSize['tabSize'] = {
        width: '',
        height: ''
      };
    }
  } else if (componentName === 'pipeline-rank') {
    const rankProductLayoutMore = componentNode.querySelector('.rank-product-layout-more');
    if (rankProductLayoutMore) {
      const imageTitle = componentNode.querySelector('.title-image');
      if (imageTitle) {
        const titleImageSize = {
          width: String(getStyle(imageTitle, 'width')),
          height: String(getStyle(imageTitle, 'height'))
        }
        adaptNodeSize['titleImageSize'] = titleImageSize;
      } else {
        adaptNodeSize['titleImageSize'] = {
          width: '',
          height: ''
        };
      }
    }
  }
  return adaptNodeSize;
}

function getStyle(dom, attr) {
  // 该方式对设置了display:none的元素不生效
  const result = dom.currentStyle ? dom.currentStyle[attr] : getComputedStyle(dom, false)[attr];
  return result.replace(/px/, '');
}

// 获取DOM节点预渲染的骨架尺寸
function getAdaptImageSize(size = {}) {
  let width = '100%', height = 'auto';
  if (!iframe && size) {
    width = size.width ? px2rem(`${size.width}px`) : '100%';
    height = size.height ? px2rem(`${size.height}px`) : 'auto';
  }
  return {
    width,
    height
  }
}

function formatTimestampToDate(data, type = 'date') {
  let time = new Date(data);
  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  let day = time.getDate();
  let hour = time.getHours();
  let min = time.getMinutes();
  let sec = time.getSeconds();
  //自定义选择想要返回的类型
  if(type === "date") {
    return `${year}-${month}-${day}`
  } else {
    return `${year}-${month}-${day} ${hour}:${min}:${sec}`
  }
}

const postPictureSizes = () => {
  const androidDpi = 1080;
  const multiple = androidDpi / 375;
  let pictureSizes = 0, pictures = 0;

  // 获取所有的img标签，并计算其占用内存的大小（这里无法获取使用了懒加载的图片元素）
  Object.values(document.getElementsByTagName('img')).forEach(item => {
    const imageSize = (item.clientWidth * multiple) * (item.clientHeight * multiple) * 4;
    pictures++;
    pictureSizes += imageSize
  });

  // 获取所有的懒加载图片元素，并计算其占用内存的大小
  Object.values(document.getElementsByClassName('lazy-load-placeholder')).forEach(item => {
    const imageSize = (item.clientWidth * multiple) * (item.clientHeight * multiple) * 4;
    pictures++;
    pictureSizes += imageSize
  });

  pictureSizes = `${parseFloat((pictureSizes / (1024 * 1024)).toFixed(2))}MB`;
  console.log(`window.onload后 一共获取到${pictures}张图片，占用内存${pictureSizes}`);
  window.parent.postMessage && window.parent.postMessage({
    msgType: 'setPictureSizes',
    pictureSizes: pictureSizes
  }, '*');
}

let hidden;
let visibilityChange;

function getSupportedProperty() {
  if (typeof document === 'undefined') return;

  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }
}

getSupportedProperty();

/**
 * 判断页面是否隐藏（进入后台）
 */
function isPageHidden() {
  if (typeof hidden === 'undefined') return false;
  return document[hidden];
}

/**
 * hack 检测是否唤端成功
 * 原理见： https://developer.mozilla.org/zh-CN/docs/Web/API/Page_Visibility_API
 * @param failure - 唤端失败回调函数
 * @param success - 唤端成功回调函数
 * @param error - 唤端异常函数
 * @param timeout - hack 失败检测延时 - 一般会触发下载
 */

export function checkOpen(
  success = () => {},
  failure = () => {},
  error = () => {},
  timeout = 1500
) {
  let haveChanged = false

  const pageChange = function (e) {
    haveChanged = true

    if (document.hidden || e.hidden || document.visibilityState == 'hidden') {
      success()
    } else {
      error()
    }

    // window.addEventListener('pagehide', pageChange, false);
    document.removeEventListener(visibilityChange, pageChange, false)
  }

  const timer = setTimeout(() => {
    clearTimeout(timer)

    if (haveChanged) {
      return
    }

    // window.addEventListener('pagehide', pageChange, false);
    document.removeEventListener(visibilityChange, pageChange, false)

    // 判断页面是否隐藏（进入后台）
    const pageHidden = isPageHidden()
    if (!pageHidden) {
      failure()
    } else {
      error()
    }

    haveChanged = true
  }, timeout)

  // window.addEventListener('pagehide', pageChange, false);
  document.addEventListener(visibilityChange, pageChange, false)
}

// 页面隐藏/关闭时，页面停留时长埋点上报，未防止漏报，同时存储埋点相关参数
function pageStayUpload(templatePti, pageOptions) {
  localStorage.setItem('stayPage', getPageId());
  localStorage.setItem('stayEnd', String(new Date().getTime()));
  localStorage.setItem('pageOptions', JSON.stringify(pageOptions));
  const stayStart = localStorage.getItem('stayStart') ? Number(localStorage.getItem('stayStart')) : null;
  const stayEnd = new Date().getTime();
  if (stayStart) {
    const duration = stayEnd - stayStart;
    if (duration > 0) {
      Object.assign(pageOptions, {
        duration
      });
      shihuo.uploadTrack({
        pti: {
          id: `${templatePti}:timeStatistics`,
          biz: JSON.stringify(pageOptions),
          pageOptions: pageOptions
        },
      })
    }
  }
}

// 页面停留时长监听及埋点上报
function pageStayTrack(templatePti, pageOptions) {

  if (typeof window === "undefined") {
    return true;
  }

  const stayPage = localStorage.getItem('stayPage');
  const stayEnd = localStorage.getItem('stayEnd');
  const stayStart = localStorage.getItem('stayStart');
  const pageOptionsLocal = localStorage.getItem('pageOptions');
  if (stayPage && stayEnd && stayStart) {
    if (stayPage != getPageId()) {
      pageOptions = pageOptionsLocal ? JSON.parse(pageOptionsLocal): {};
    }
    const duration = Number(stayEnd) - Number(stayStart);
    if (duration > 0) {
      Object.assign(pageOptions, {
        duration
      });
      shihuo.uploadTrack({
        pti: {
          id: `${templatePti}:timeStatistics`,
          biz: JSON.stringify(pageOptions),
          pageOptions: pageOptions
        },
      });
    }
    localStorage.removeItem('stayPage');
    localStorage.removeItem('stayEnd');
    localStorage.removeItem('pageOptions');
  }

  localStorage.setItem('stayStart', String(new Date().getTime()));

  window.addEventListener('beforeunload', () => {
    pageStayUpload(templatePti, pageOptions);
  });

  if (getParams('community_tab') != '1') {
    // 基于页面可见性API，在页面可见时记录停留开始时间，在页面隐藏时计算停留时长，进行埋点上报
    document.addEventListener('visibilitychange', (event) => {
      if (document.hidden) {
        // 页面隐藏时，计算停留时长，并进行埋点上报
        pageStayUpload(templatePti, pageOptions);
      } else {
        // 页面可见时，重置页面停留开始时间
        localStorage.setItem('stayStart', String(new Date().getTime()));
      }
    }); 
  }
}

// 数组指定范围随机
function arrayRangeRandom(array, n) {
  // 判断数组长度是否小于等于N，如果是则返回原数组
  if (array.length < n) {
    return array;
  }
  
  // 复制数组的前N项到一个新数组
  const firstN = array.slice(0, n);
  
  // 对新数组进行随机排序
  for (let i = firstN.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = firstN[i];
    firstN[i] = firstN[j];
    firstN[j] = temp;
  }
  
  // 将新数组的排序结果与原数组的剩余项进行合并
  var result = firstN.concat(array.slice(n));
  
  return result;
}

function richTextToPlainText(richText) { 
  // 创建一个空的 DOM 元素 
  const el = document.createElement('div'); 
  // 将富文本字符串设置为元素的 innerHTML 
  el.innerHTML = richText; 
  // 返回元素的文本内容 
  return el.textContent; 
}

function getOptionImageSize(imageUrl, widthRange = 100) {
  if (scene === 'shihuoApp') {
    return {
      width: `${widthRange || 100}%`,
      height: 'auto'
    } 
  } else {
    return {
      width: `100px`,
      height: 'auto'
    }
  }
}

/**
 * 获取富文本中的img标签，并根据指定规则设置img的宽高，最后返回富文本
 */
function processImageTagImg(richText) {
  if (scene === 'shihuoApp') {
    return richText.replace(/<img[^>]+src=["']([^"']*?)_([0-9]+)x([0-9]+)\.[^"']+["'][^>]*>/g, (match, src, width, height) => {  
      if (width && height) {
        let imageW = width / 3;
        let imageH = height / 3;
        if (imageW < 335 && imageH < 335) {
          // 原始宽高除以3后均小于335
          return match.replace(/<img/, `<img width="${imageW}" height="${imageH}"`);  
  
        } else if (imageW > 335 || imageH > 335) {
          // 原始宽高除以3后，其中任意一边大于335
          if (imageW > imageH) {
            // 宽高比大于1
            return match.replace(/<img/, `<img width="${335}" height="auto"`);
  
          } else if (imageW < imageH) {
            // 宽高比小于1
            return match.replace(/<img/, `<img width="auto" height="${335}"`);
  
          } else {
            // 宽高比等于1
            return match.replace(/<img/, `<img width="${335}" height="${335}"`);  
  
          }
        }
      }
    });
  } else {
    return richText.replace(/<img\s+[^>]*src="([^"]+)"[^>]*>/g, (match, src) => {
      const newSrc = formatImgUrl(src, true);
      return match.replace(src, newSrc);  
    });
  }
} 

// 指定范围内的img标签添加大图预览
function onImageClickEvent(target) {
  const white_list = [
    'static.shihuocdn.cn/admin/files/20230712/bd166bc8497abec9a9cbcad38e59ca4f.png',
    'static.shihuocdn.cn/admin/files/20230517/af9925ea87559fcdb9ad499215c80734.png',
    'static.shihuocdn.cn/admin/files/20230712/36fda26aabba8e475eb09aaf2d9ffaa0.png',
    'static.shihuocdn.cn/admin/files/20230517/ae7db1e4810f0dd30648eed6f395bad7.png',
    'static.shihuocdn.cn/admin/files/20230712/2d3a4bad8b873a139c64c12fb0c96e18.png',
    'static.shihuocdn.cn/admin/files/20230712/22f2760d4489589b8173dc2ce0dadf45.png',
    'static.shihuocdn.cn/admin/files/20230518/c5266c4d31d322f93a8d42203071e61c.png'
  ]
  const allImgsTag = target && target.querySelectorAll('img'); 
  // 遍历每个 img 标签并添加点击事件监听器  
  if (allImgsTag && allImgsTag.length > 0) {
    allImgsTag.forEach((item) => {
      if (item && !item.hasAttribute('preview')) {
        item.setAttribute('preview', true);
        const disabled = item.getAttribute('class') && item.getAttribute('class').includes('禁用');
        if (!disabled && !white_list.includes(item.src.replace(/^(https?:\/\/)/, ''))) {
          // class没有设置disabled  且不在白名单范围内的图片，绑定点击事件
          item.addEventListener('click', () => {
            if (isShihuo()) {
              window.Jockey.send('images', {
                index: '1',
                list: [item.src]
              });
            } else {
              if (scene === 'parttimePlatform') {
                // 兼职平台场景的问卷，点击图片大图预览
                imagePreviewPC(item.src);
              } else {
                window.open(item.src);
              }
            }
          });
        }
      }
    }); 
  }
}

// 富文本标签图片大图预览
function imagePreviewPC(imgUrl) {
  // 创建蒙层和图片元素  
  const overlay = document.createElement('div');  
  const preview = document.createElement('img');
  const close = document.createElement('img');

  // 设定蒙层的样式  
  overlay.style.position = 'fixed';  
  overlay.style.top = '0';  
  overlay.style.left = '0';  
  overlay.style.width = '100%';  
  overlay.style.height = '100%';  
  overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.85)';  
  overlay.style.display = 'flex';  
  overlay.style.justifyContent = 'center';  
  overlay.style.alignItems = 'center';  
  overlay.style.zIndex = '99999'; // 确保蒙层在最上面 
  overlay.style.cursor = 'pointer';

  // 设定大图的样式  
  preview.style.maxWidth = '90%';  
  preview.style.maxHeight = '90%';
  preview.style.cursor = 'pointer';

  // 设置关闭按钮样式
  close.style.position = 'absolute';  
  close.style.top = '24px';
  close.style.right = '24px';  
  close.style.width = '24px';  
  close.style.height = '24px';  
  close.style.cursor = 'pointer';

  // 将蒙层和大图添加到文档中  
  overlay.appendChild(preview);  
  overlay.appendChild(close); 
  document.body.appendChild(overlay); 

  preview.src = imgUrl;
  close.src = 'https://sh1.shihuocdn.cn/images/bargain/close.png';
  overlay.style.display = 'flex';

  // 点击蒙层隐藏大图和蒙层  
  overlay.addEventListener('click', setOverlayState);
  preview.addEventListener('click', setOverlayState);
  close.addEventListener('click', setOverlayState);

  function setOverlayState (){
    overlay.removeEventListener('click', setOverlayState);
    preview.removeEventListener('click', setOverlayState);
    close.removeEventListener('click', setOverlayState);
    document.body.removeChild(overlay);
  }
}

/**
 * 主要用来获取页面里所有超链，并判断超链是否为图片，若为图片则给图片添加大图预览功能
 */
function processImageTagA() {
  // 获取所有的 a 标签
  const allTagA = document.querySelectorAll('a');
  if (allTagA && allTagA.length > 0) {
    const imageRegex = /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i;  
    allTagA.forEach(tagA => {
      const href = tagA.getAttribute('href');
      if (href && imageRegex.test(href)) {
        const bindEvent = tagA.getAttribute('bindEvent');
        if (!bindEvent) {
          tagA.setAttribute('bindEvent', true);
          tagA.onclick = (event) => {  
            event.preventDefault(); // 阻止默认的点击行为  
            if (isShihuo() && typeof window !== 'undefined') {
              window.Jockey.send('images', {
                index: '1',
                list: [href]
              });
            } else {
              window.open(href);
            }
          };
        }
      }
    }); 
  }
}

function hexColorToRgba(hexColor, opacity) {
  const alphaMaxVal = 1
  hexColor = hexColor.replace("#", "");

  //用于分割16进制色彩通道
  let reg = new RegExp("\\w{1,2}", "g");
  //分割颜色通道
  let rgbaArray255 = hexColor.match(reg);
  rgbaArray255 = rgbaArray255 && rgbaArray255.map((channel, index) => {
    //计算每个通道的10进制值
    let colorVal = parseInt(channel, 16);
    if (index === 3) {
      //这是alpha通道
      return Math.round(colorVal / (255 / alphaMaxVal) * 100) / 100
    }
    return colorVal;
  });
  return `rgb(${rgbaArray255.join(',')},${opacity})`;
}

/**
 * 主要用来价格截断,不用四舍五入,且返回是否需要显示万位价格,已把小数截取,返回数组
 * @param {*} baseNum 数
 * @param {*} decimals 截取的位数
 * @param {*} unit 需要达到的标准数
 * @returns 
 */
 function truncateDecimals (baseNum, decimals, unit=10000) {
  if (baseNum && unit && baseNum*1 >= unit) {
    let regEx = new RegExp("(\\d+\\.\\d{" + decimals + "})");
    let num = baseNum / unit
    let matches = num.toString().match(regEx);
    matches = matches ? parseFloat(matches[1]) : num.valueOf();
    return (matches.toString()).split('.')
  }
  return [];
}

/**
 * 主要用来价格截断,不用四舍五入,且返回是否需要显示万位价格,已把小数截取,返回对象
 * @param {*} baseNum 数
 * @param {*} decimals 截取的位数
 * @param {*} unit 需要达到的标准数
 * @returns 
 */
 function priceConversion (baseNum, decimals) {
   let unit = 1;//千位小数位需要缩小
   if (baseNum >= 10000 && baseNum < 100000000) {
     unit = 10000
   } else if (baseNum >= 100000000) {
     unit = 100000000
   }
  if (baseNum && unit && baseNum*1 >= unit) {
    let regEx = new RegExp("(\\d+\\.\\d{" + decimals + "})");
    let num = baseNum / unit
    let matches = num.toString().match(regEx);
    matches = matches ? parseFloat(matches[1]) : num.valueOf();
    let list = (matches.toString()).split('.');
    let unitStr = '';
    if (baseNum >= 10000 && baseNum < 100000000) {
      unitStr = '万'
    } else if (baseNum >= 100000000) {
      unitStr = '亿'
    }
    return {
      list,
      unit:unitStr
    }
  }
  return null;
}

/**
 * 是否可以显示右边原价格
 * @param {*} priceLength 价格长度
 * @param {*} originalPrice 原价
 * @param {*} unit 显示的长度标准
 * @returns 
 */
function  showRightPrice (priceLength, originalPrice, unit=8) {
   let length = originalPrice ? originalPrice.toString().length : 0
   return priceLength + length <= unit
}

// 获取沉浸式导航栏的高度和内边距
function getNavigationBarInfo() {
  let navigationBarPaddingTop = 0, navigationBarHeight = 0;
  if (SHDiffVersion(getVersion(), '6.84.0')) {
    navigationBarPaddingTop = isIphoneX() ? 44 : isAndroid() ? 43 : 20
    if (isIphone14ProMax()) {
      navigationBarPaddingTop = statusBarHeight || 54;
    }
    if (isTablet) {
      navigationBarPaddingTop = 24;
    }
  } else {
    navigationBarPaddingTop = isIphoneX() ? 44 : isAndroid() ? 0 : 20
    if (isIphone14ProMax()) {
      navigationBarPaddingTop = statusBarHeight || 54;
    }
    if (isTablet) {
      navigationBarPaddingTop = 60;
    }
  }
  if (isTablet) {
    navigationBarHeight = innerWidth > 600 ? 40 : 60;
  } else {
    navigationBarHeight = isAndroid() ? 42 : 48;
  }
  navigationBarHeight = navigationBarHeight + navigationBarPaddingTop;
  return {
    navigationBarPaddingTop,
    navigationBarHeight
  }
}

function loadWeixinJsSdk() {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//sh1.shihuocdn.cn/js/lib/weixinJsSdk.js';
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject(new Error('加载callAppLib.js失败'));
    };
    document.head.appendChild(script);
  });
}

function judgeIsTabletDevice() {
  return isTabletDevice;
}

export default {
  isAndroid: isAndroid,
  isHuPuAPP: isHuPuAPP,
  parseToken: parseToken,
  isShihuo: isShihuo,
  getParams: getParams,
  getUrlParams: getUrlParams,
  getQueryString: getQueryString,
  getCookie: getCookie,
  convertHref,
  copyToClipBoard,
  parseQueryStringParams,
  isIphoneX: isIphoneX,
  isIphone14ProMax: isIphone14ProMax,
  getTPExtra,
  formatTPExtraData,
  jumpToUrl,
  getDeviceInfo,
  asyncForEach,
  getWeightRandom,
  handleToufangClick,
  getPageId,
  toast,
  getVersion,
  SHDiffVersion,
  formatImgUrl,
  uploadTrack,
  getExposureData,
  postComponentSizeToEditor,
  formatTimestampToDate,
  checkOpen,
  pageStayTrack,
  pageStayUpload,
  SyncComponentsSizeAsync,
  arrayRangeRandom,
  richTextToPlainText,
  getOptionImageSize,
  processImageTagImg,
  processImageTagA,
  onImageClickEvent,
  hexColorToRgba,
  truncateDecimals,
  showRightPrice,
  priceConversion,
  getAdaptImageSize,
  getNavigationBarInfo,
  loadWeixinJsSdk,
  judgeIsTabletDevice,
};


// WEBPACK FOOTER //
// ./utils/utils.js